import { useCallback, useState, useSyncExternalStore } from 'react'
import { getThemeState, setPreference, subscribeTheme } from '../utils/theme.ts'

export const useDarkMode = () => {
    const { preference, systemDark } = useSyncExternalStore(subscribeTheme, getThemeState)

    const darkModeEnabled = preference === 'system' ? systemDark : preference === 'dark'

    const switchDarkMode = useCallback(() => {
        setPreference(darkModeEnabled ? 'light' : 'dark')
    }, [darkModeEnabled])

    return { darkModeEnabled, preference, setPreference, switchDarkMode }
}

export const usePublicDarkMode = () => {
    const [darkModeEnabled, setDarkModeEnabled] = useState(false)

    const switchDarkMode = useCallback(() => {
        setDarkModeEnabled((prev) => !prev)
    }, [])

    return {
        darkModeEnabled,
        switchDarkMode,
    }
}
